import { render } from "./UpperMenu.vue?vue&type=template&id=1e2b0533"
import script from "./UpperMenu.vue?vue&type=script&lang=js"
export * from "./UpperMenu.vue?vue&type=script&lang=js"

import "./UpperMenu.vue?vue&type=style&index=0&id=1e2b0533&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__